import produce from 'immer';
import { Actions } from './action';
import {
    AddressForm,
    AvcState,
} from './interface';
import { AvcAction } from './enum';
import { Address } from '@vfde-sails/avc-core';

export const initialState: AvcState = {
    error: undefined,
    addressForm: {
        city: '',
        street: '',
        number: '',
    },
    addresses: [],
};

const getAddressForm = (address: Address): AddressForm => ({
    city: address.city || '',
    street: address.street || '',
    number: `${address.housenumber || ''}${address.housenumberextra || ''}`,
});

const avcReducer = (state = initialState, action: Actions) =>
    produce(state, draft => {
        switch (action.type) {
            case AvcAction.SET_ERROR:
                draft.error = action.error;
                break;
            case AvcAction.SET_INPUT:
                if (action.value === draft.addressForm[action.name]) {
                    return;
                }

                draft.addressForm[action.name] = action.value;
                draft.selectedAddress = undefined;
                break;
            case AvcAction.SET_SELECTED_ADDRESS:
                draft.selectedAddress = action.address ?? draft.addresses[action.index];

                if (draft.selectedAddress) {
                    draft.addressForm = getAddressForm(draft.selectedAddress);
                }

                break;
            case AvcAction.SET_ADDRESSES:
                draft.addresses = action.addresses;
                draft.selectedAddress = action.addresses[0];

                if (draft.selectedAddress) {
                    draft.addressForm = getAddressForm(draft.selectedAddress);
                }

                break;
            case AvcAction.RESET_FORM:
                draft.addressForm = { ...initialState.addressForm };
                draft.addresses = [];
                draft.selectedAddress = undefined;
        }
    });

export default avcReducer;
